function fbqSeguro(tipo, evento, params = {}) {
    if (typeof window.fbq !== "function") return;
    window.fbq(tipo, evento, params);
}




export function pixelVerContenido({ nombre, id, precio, categoria }) {
    fbqSeguro("track", "ViewContent", {
        content_name:  nombre,
        content_ids:   [id],
        content_type:  "product",
        value:         precio,
        currency:      "COP",
        content_category: categoria || "",
    });
}



export function pixelAgregarAlCarrito({ nombre, id, precio, categoria }) {
    fbqSeguro("track", "AddToCart", {
        content_name:  nombre,
        content_ids:   [id],
        content_type:  "product",
        value:         precio,
        currency:      "COP",
        content_category: categoria || "",
    });
}



export function pixelIniciarReserva({ nombre, id, precio }) {
    fbqSeguro("track", "InitiateCheckout", {
        content_name:  nombre,
        content_ids:   [id],
        content_type:  "product",
        value:         precio,
        currency:      "COP",
        num_items:     1,
    });
}



export function pixelCompraCompletada({ transaccionId, monto, moneda = "COP" }) {
    fbqSeguro("track", "Purchase", {
        value:    monto,
        currency: moneda,
        order_id: transaccionId,
    });
}

// Evento aparte (sin value/currency) para no duplicar el conteo de compras ni el ingreso reportado
// en "Purchases" de Ads Manager — solo sirve para armar audiencias/reportes de quién usó el descuento.
export function pixelPrimeraCompraDescuento({ transaccionId, montoDescuento }) {
    fbqSeguro("trackCustom", "PrimeraCompraDescuento", {
        order_id:        transaccionId,
        monto_descuento: montoDescuento,
    });
}



export function pixelAgregarFavorito({ nombre, id, precio }) {
    fbqSeguro("track", "AddToWishlist", {
        content_name: nombre,
        content_ids:  [id],
        value:        precio,
        currency:     "COP",
    });
}



// Clic en "Más servicios de ..." / "Servicios similares" (serviciosRelacionados.jsx). Custom: Meta no
// tiene un evento estándar de "elegir de una lista". bloque: "vendedor" | "similares".
export function pixelClickServicioRelacionado({ bloque, idOrigen, idDestino, nombre, categoria, posicion }) {
    fbqSeguro("trackCustom", "ClickServicioRelacionado", {
        bloque,
        id_origen:        idOrigen,
        content_ids:      [idDestino],
        content_name:     nombre || "",
        content_category: categoria || "",
        content_type:     "product",
        posicion,
    });
}



export function pixelRegistroCompletado({ metodo = "email" }) {
    fbqSeguro("track", "CompleteRegistration", {
        content_name: "Registro Zervicy",
        currency:     "COP",
        status:       true,
        value:        0,
    });
}



export function pixelClickDescargaApp({ plataforma }) {
    fbqSeguro("trackCustom", "ClickDescargaApp", {
        plataforma, // "ios" o "android"
    });
}



export function pixelSuscribirKlaviyo({ origen = "formulario" }) {
    fbqSeguro("trackCustom", "SuscribirKlaviyo", {
        origen, // "footer", "cuenta", "registro"
    });
}



export function pixelPonerEnRevision({ idServicio, categoria }) {
    fbqSeguro("trackCustom", "PonerEnRevision", {
        idServicio,
        categoria,
    });
}



export function pixelIniciarCreacionServicio() {
    fbqSeguro("trackCustom", "IniciarCreacionServicio");
}



export function pixelPasoCreacionServicio({ paso, totalPasos }) {
    fbqSeguro("trackCustom", "PasoCreacionServicio", { paso, totalPasos });
}



export function pixelClickLlamarAyuda({ numero }) {
    fbqSeguro("trackCustom", "ClickLlamarAyuda", {
        numero,
    });
}



export function pixelClickWhatsAppAyuda() {
    fbqSeguro("trackCustom", "ClickWhatsAppAyuda");
}



// "Search" es uno de los ~17 eventos ESTÁNDAR de Meta (no custom) — se dispara en las 4 variantes
// de búsqueda (lista, mapa por ciudad, cerca de mí desde Búsqueda, cerca de mí en Home).
export function pixelBusquedaRealizada({ termino, categoria }) {
    fbqSeguro("track", "Search", {
        search_string: termino || "",
        content_category: categoria || "",
        content_type: "product",
    });
}